import { render, staticRenderFns } from "./checkbox-custom.vue?vue&type=template&id=11b53b06"
import script from "./checkbox-custom.vue?vue&type=script&lang=js"
export * from "./checkbox-custom.vue?vue&type=script&lang=js"
import style0 from "./checkbox-custom.vue?vue&type=style&index=0&id=11b53b06&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11b53b06')) {
      api.createRecord('11b53b06', component.options)
    } else {
      api.reload('11b53b06', component.options)
    }
    module.hot.accept("./checkbox-custom.vue?vue&type=template&id=11b53b06", function () {
      api.rerender('11b53b06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/components/form-elements/checkbox-custom.vue"
export default component.exports